import { render } from "./BoardTop.vue?vue&type=template&id=419ff3b1"
import script from "./BoardTop.vue?vue&type=script&lang=js"
export * from "./BoardTop.vue?vue&type=script&lang=js"
script.render = render

export default script